import styled from 'styled-components';
import {alignContentCss} from '../../styles/align.styled';
import {boxCss} from '../../styles/box.styled';


export const ImageListStyled = styled.div`
  ${boxCss};

  .dfl-image-list {
    display: flex;
    flex-wrap: wrap;

    ${alignContentCss}
    > div {
      margin: 12px;
    }
  }

`;

